/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import { Question } from '@staffino/model';

export function lowerBoundLabel(question: Question, t: Function) {
  if (question.lowerBoundLabel) {
    return question.lowerBoundLabel;
  }
  if (question.metric === 'CES') {
    if (question.upperBoundScore === 5) {
      return t('Very high effort');
    }
    if (question.upperBoundScore === 7) {
      return t('Strongly disagree');
    }
  }
  if (question.metric === 'CSAT') {
    return t('Poor');
  }
  if (question.metric === 'FCR') {
    return t('No');
  }
  if (question.metric === 'NPS') {
    return t('Not likely');
  }
  if (!question.metric) {
    return t('Poor');
  }
}

export function upperBoundLabel(question: Question, t: Function) {
  if (question.upperBoundLabel) {
    return question.upperBoundLabel;
  }
  if (question.metric === 'CES') {
    if (question.upperBoundScore === 5) {
      return t('Very low effort');
    }
    if (question.upperBoundScore === 7) {
      return t('Strongly agree');
    }
  }
  if (question.metric === 'CSAT') {
    return t('Excellent');
  }
  if (question.metric === 'FCR') {
    return t('Yes');
  }
  if (question.metric === 'NPS') {
    return t('Extremely likely');
  }
  if (!question.metric) {
    return t('Excellent');
  }
}
